import {StationType} from "@SearchResults/types/station/Station.type";
import addOrRemoveObjectToArray from "@Array/addOrRemoveObjectToArray";

export default function addOrRemoveStationFromFilteredList(stations: StationType[], station: StationType) {
    return addOrRemoveObjectToArray(stations, station, 'id');
}